package pwgs.ui.scenes.trialsettingsscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(TrialSettingsSceneProps::class, TrialSettingsSceneModel::class)
interface TrialSettings {

    fun load()
    fun startTrialSeason(days: Int)
    fun stopTrialSeason()

}

@Serializable
data class TrialSettingsSceneProps(val projectId: Long)

@Serializable
class TrialSettingsSceneModel(
    val trialSeasonStartedAt: String,
    val trialDays: Int
) {
    var isLoading: Boolean = true
}